import _ from 'lodash';
import {
    ContactInformationAttributes,
    Entity,
    EntityType,
    Store,
} from '@treez/commons/sharedTypings/directory';
import callAPI from '~/utils/callAPI';
import {DIRECTORY_API_URL} from './Constants';

export const getUserHints = async (userAuthId: any) => {
    const data = await callAPI(`${DIRECTORY_API_URL}/entities`);

    const entities = data.data as Entity[];

    const mappedHints = _.reduce(
        entities,
        (result, entity, key) => {
            switch (entity.type) {
                case EntityType.BRAND:
                    result.brandIds.push(entity.typeId);
                    break;
                case EntityType.ORGANIZATION:
                    result.orgIds.push(entity.typeId);
                    break;
                case EntityType.STORE:
                    result.storeIds.push(entity.typeId);
                    break;
                default:
                    break;
            }

            return result;
        },
        {storeIds: [], orgIds: [], brandIds: []} as {
            storeIds: number[];
            orgIds: number[];
            brandIds: number[];
        }
    );

    return mappedHints;
};

export const getOrganization = async (typeId: number) => {
    const {data: entity} = await callAPI(`${DIRECTORY_API_URL}/organizations/${typeId}`);

    return entity as Entity;
};

export const getStores = async (orgEntityId: number) => {
    const {data: entities} = await callAPI(
        `${DIRECTORY_API_URL}/entities/${orgEntityId}/children?type=${EntityType.STORE}`
    );

    return entities as Store[];
};

export const getStoreContactInformation = async (storeTypeId: number) => {
    const {data} = await callAPI(`${DIRECTORY_API_URL}/stores/${storeTypeId}/contactInformation`);

    return data as ContactInformationAttributes[];
};
